export const AdminRoles = new Set([
  'superAdmin',
  'trainingAdmin',
  'clinicAdmin',
]);
